import { Col, Row, Space, Typography } from "antd";
import { ContactForm } from "../../../components/ContactForm";
import styles from "./Contacts.module.scss";
import { useTranslation } from "react-i18next";
import { VerifiedLogo } from "../../../components/VerifiedLogo/VerifiedLogo";

export const Contacts: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <Row className={styles.row}>
        <Col xs={24} lg={10}>
          <Space
            direction="vertical"
            style={{ justifyContent: "space-between", height: "100%" }}
          >
            <Typography.Title level={1} className={styles.title}>
              {t("contact.contactUs")}
            </Typography.Title>
            <VerifiedLogo />
          </Space>
        </Col>
        <Col xs={24} lg={14}>
          <ContactForm />
        </Col>
      </Row>
    </div>
  );
};
